import classNames from 'classnames';
import React from 'react';

import styles from './fixed-notifications.scss';

interface Props {
  children: any;
  fullWidth?: boolean;
}

// TODO: fix notifications width style
const FixedNotifications = ({ children, fullWidth }: Props) => (
  <div
    className={classNames(styles.fixedNotifications, {
      [styles.fullWidth]: fullWidth,
    })}
  >
    {children}
  </div>
);

export default FixedNotifications;
